import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function LoginPage() {
    const { login } = useAuth();
    const navigate = useNavigate();
    const [form, setForm] = useState({ email: '', password: '' });
    const [loading, setLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);

    const handleChange = (e) => setForm(f => ({ ...f, [e.target.name]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.email || !form.password) return toast.error('Please fill all fields');
        setLoading(true);
        try {
            await login(form.email, form.password);
            toast.success('Welcome back!');
            navigate('/dashboard');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Login failed');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page">
            <div className="auth-card">
                <div className="auth-logo">🎓</div>
                <h1 className="auth-title">LeadPro CRM</h1>
                <p className="auth-subtitle">Sign in to manage your leads</p>

                <form className="auth-form" onSubmit={handleSubmit} id="login-form">
                    <div className="form-group">
                        <label htmlFor="login-email">Email Address</label>
                        <input
                            id="login-email"
                            type="email"
                            name="email"
                            placeholder="admin@crm.com"
                            value={form.email}
                            onChange={handleChange}
                            autoComplete="email"
                            autoFocus
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="login-password">Password</label>
                        <div style={{ position: 'relative' }}>
                            <input
                                id="login-password"
                                type={showPass ? 'text' : 'password'}
                                name="password"
                                placeholder="••••••••"
                                value={form.password}
                                onChange={handleChange}
                                autoComplete="current-password"
                                style={{ paddingRight: '44px' }}
                            />
                            <button
                                type="button"
                                onClick={() => setShowPass(s => !s)}
                                style={{
                                    position: 'absolute', right: '12px', top: '50%',
                                    transform: 'translateY(-50%)', background: 'none',
                                    border: 'none', cursor: 'pointer', color: 'var(--text-muted)',
                                    fontSize: '1rem', padding: 0, lineHeight: 1,
                                }}
                                aria-label="Toggle password visibility"
                            >
                                {showPass ? '🙈' : '👁'}
                            </button>
                        </div>
                    </div>
                    <button
                        id="login-submit"
                        type="submit"
                        className="btn btn-primary btn-full btn-lg"
                        disabled={loading}
                        style={{ marginTop: '8px' }}
                    >
                        {loading ? <><span className="spinner" style={{ width: 16, height: 16, borderWidth: 2 }} />Signing in…</> : '🔑  Sign In'}
                    </button>
                </form>

                <div className="auth-footer">
                    <p style={{ marginBottom: '8px' }}>Demo credentials:</p>
                    <p>Admin: <strong>admin@crm.com</strong> / <strong>Admin@123</strong></p>
                    <p>Counselor: <strong>john@crm.com</strong> / <strong>Admin@123</strong></p>
                </div>
            </div>
        </div>
    );
}
